import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIdCard,
  faPaperPlane,
  faQuestionCircle,
  faRocket,
} from "@fortawesome/free-solid-svg-icons";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  Switch,
  BrowserRouter,
} from "react-router-dom";
import NavbarTop from "./NavbarTop";
import Footer from "./Footer";
import MenuCategories from "./MenuCategories";
import MenuInicioRapido from "./MenuInicioRapido";

export default function Pages() {
  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Tutorial Rápido</li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuCategories />
            </div>

            <div className="col-md-5">
              <h1>
                <FontAwesomeIcon icon={faRocket} size="1x" /> Tutorial Rápido
              </h1>
              <hr />

              <p className="content">
                Tudo que você precisa para começar a operar a plataforma Sales
                Box
              </p>

              <ul className="nav flex-column articles-listing">
                <li className="faq-item mb-5">
                  <Link to="/integracao">
                    <FontAwesomeIcon icon={faQuestionCircle} size="1x" /> Como
                    conectar minha conta do Facebook ou Instagram?
                  </Link>
                </li>

                <li className="faq-item mb-5">
                  <Link to="/como-enriquecer-meus-dados">
                    <FontAwesomeIcon icon={faQuestionCircle} size="1x" /> Como
                    enriquecer meus dados?
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
